export var ScanState;
(function (ScanState) {
    ScanState["COMPLETED"] = "Complete";
    ScanState["FAILED"] = "Failed";
    ScanState["WAITING"] = "Waiting";
    ScanState["PROCESSING"] = "Processing";
    ScanState["SKIPPED"] = "Skipped";
})(ScanState || (ScanState = {}));
